import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWiproComponent } from './simple-icons-wipro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWiproComponent ],
    exports:      [ SimpleIconsWiproComponent ],
    bootstrap:    []
})
export class SimpleIconsWiproModule {}
